// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.GetPaymentHistoryPdfHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

export const GetPaymentHistoryPdfHandler_getPaymentHistoryPdf_Path = '/api/web/v1/getPaymentHistoryPdf';

/**
 * get payment history pdf content
 */
export const GetPaymentHistoryPdfHandler_getPaymentHistoryPdf = (client = getClient()) => {
  return httpFrontEndRequest<never, never, string>(
    {
      endpoint: GetPaymentHistoryPdfHandler_getPaymentHistoryPdf_Path,
      method: 'GET',
      contextPath: '/rent-payment',
    },
    client,
  );
};
